// extracted by mini-css-extract-plugin
module.exports = {"grid":"AddressVerificationModal_grid__2avfl"};